import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';

import { MsiRepository } from '@app/domain/ports/tpv/msi.repository';
import { TpvMsiPlan } from '@app/domain/models/tpv/msi.model';

/** Mock de planes MSI para pruebas sin backend (tpvUseMocks). */
@Injectable()
export class MsiMockDataSource extends MsiRepository {
  override getMsiPlans(_externalIdMerchant: string): Observable<TpvMsiPlan[]> {
    const plans: TpvMsiPlan[] = [
      { months: 3, minAmount: 300, rate: 0 },
      { months: 6, minAmount: 600, rate: 0 },
      { months: 12, minAmount: 1200, rate: 0 },
    ];

    return of(plans).pipe(delay(300));
  }
}
